import hangman_0 from '../assets/hangman_0.svg';
import hangman_1 from '../assets/hangman_1.svg';
import hangman_2 from '../assets/hangman_2.svg';
import hangman_3 from '../assets/hangman_3.svg';
import hangman_4 from '../assets/hangman_4.svg';
import hangman_5 from '../assets/hangman_5.svg';
import hangman_6 from '../assets/hangman_6.svg';

const visualHangman = {
    6: hangman_0,
    5: hangman_1,
    4: hangman_2,
    3: hangman_3,
    2: hangman_4,
    1: hangman_5,
    0: hangman_6
}

export default visualHangman;